import { RendererProvider } from "@atlassiansox/bxp-content-framework";

import {
    FooterContextProvider,
    AnalyticsAttributesProvider
} from "../../components";
import { PageModel } from "../../models";
import { renderViewModels, renderViewModel } from "../../render-view-model";
import { MapModelToProps } from "../../utils";

export type PageProps = MapModelToProps<PageModel>;

const Page = ({ model }: PageProps) => {
    const {
        entryTitle,
        header,
        sections = [],
        footer,
        noIndexTag
    } = model.content;

    const sharedPageAttributes = {
        stack: "arcadia",
        isIndexed: !noIndexTag
    };

    return (
        <RendererProvider renderer={renderViewModel}>
            <FooterContextProvider>
                <AnalyticsAttributesProvider
                    value={{
                        ...sharedPageAttributes,
                        labelEnglish: entryTitle
                    }}
                >
                    {header && renderViewModel(header)}
                    <main id="skip-target" tabIndex={-1}>
                        {renderViewModels(sections)}
                    </main>
                    {footer && renderViewModel(footer)}
                </AnalyticsAttributesProvider>
            </FooterContextProvider>
        </RendererProvider>
    );
};

export default Page;
